/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicKorean = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M387 171h897q-64 230-179 422T834 945t-343 289-396 232l-84-120q180-68 339-172t302-232q149-135 260-291t179-347H354l33-133zm1214 620h344l-33 133h-344l-250 996h-149L1651 0h149l-199 791z"
    }));
export default SvgItalicKorean;
